import { render, staticRenderFns } from "./ProducerSidebar.vue?vue&type=template&id=0c20073e&scoped=true&"
import script from "./ProducerSidebar.vue?vue&type=script&lang=js&"
export * from "./ProducerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20073e",
  null
  
)

export default component.exports